import Flex from 'components/ui/Flex';
import CssSphere from 'components/ui/CssSphere';
import Text from 'components/ui/Text';
import { ReturnStatusType } from 'returnCenter-api';
import styled from 'styled-components';

type OrderStatusProps = {
    statusTranslation?: string;
    status: ReturnStatusType | null;
    size?: number;
};

const OrderStatus = ({ size, status, statusTranslation }: OrderStatusProps) => {
    return (
        <Flex className="cssSphere-wrapper" align="center">
            <CssSphere size={size} color={getStatusColor(status)} />
            <StyledLabel padding="0" as="h2" thin fontSize={22}>
                {statusTranslation}
            </StyledLabel>
        </Flex>
    );
};

export default OrderStatus;

const StyledLabel = styled(Text)`
    margin: 0 0 0 0.5rem;
`;

//helper function to add correct color to the status sphere
export const getStatusColor = (status: ReturnStatusType | null) => {
    switch (status) {
        case ReturnStatusType.Created:
            return '#b6b3b3e3';
        case ReturnStatusType.ItemsSelected:
            return '#1abc9c';
        case ReturnStatusType.IncomingPackage:
            return '#9b59b6';
        case ReturnStatusType.Received:
            return '#3498db';
        case ReturnStatusType.InProgress:
            // return '#f1c40f';
            return '#f09411';
        case ReturnStatusType.OnHold:
            return '#e74c3c';
        case ReturnStatusType.CreditError:
            return '#c0392b';
        case ReturnStatusType.CreditedBatchPending:
            return '#2ecc71';
        case ReturnStatusType.BatchHandled:
            return '#16a085';
        case ReturnStatusType.Completed:
            return '#07bc0c';
        default:
            return '#b6b3b3e3';
    }
};
